import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 新增 ");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("启用");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("停用");

const _hoisted_6 = {
  key: 1
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode("查看");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑");

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';
import { getVarietyList, varietyUpdateStatus } from '@/request';
import { getVexTableProps } from '@/config';
export default {
  name: 'VarietyList',

  setup(__props) {
    const router = useRouter();
    const form = ref({
      prodName: '',
      goodsId: '',
      status: ''
    });
    const table = ref();
    const tableOptions = getVexTableProps({
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        field: 'coverUrl',
        title: '主图',
        width: '90px',
        slots: {
          default: 'cover'
        }
      }, {
        field: 'prodName',
        title: '品种名称',
        minWidth: '180px',
        showOverflow: true
      }, {
        field: 'goodsId',
        title: '商品ID',
        width: '140px',
        showOverflow: true
      }, {
        field: 'status',
        title: '状态',
        width: '90px',

        formatter({
          cellValue
        }) {
          return cellValue === 1 ? '启用' : '停用';
        }

      }, {
        field: 'createBy',
        title: '创建人',
        width: '120px',
        showOverflow: true
      }, {
        field: 'updateAt',
        title: '更新时间',
        width: '170px'
      }, {
        title: '操作',
        fixed: 'right',
        width: '160px',
        slots: {
          default: 'operation'
        }
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getVarietyList(_objectSpread({
              page: page.currentPage,
              pageSize: page.pageSize
            }, form.value)).then(data => {
              res({
                total: data.data.totalSize,
                result: data.data.list
              });
            });
          })
        }
      }
    });

    function goEdit(row, isSee) {
      router.push({
        name: 'SaveVariety',
        query: _objectSpread({
          id: row.varietyId
        }, isSee ? {
          isSee: true
        } : {})
      });
    }

    function updateStatus(status) {
      const statusStr = status === 1 ? '启用' : '停用';
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请选择要操作的品种');
        return;
      }

      ElMessageBox.confirm(`是否确认${statusStr}`, {
        title: statusStr
      }).then(() => {
        varietyUpdateStatus({}, {
          params: {
            status,
            varietyIdList: selectRows.map(item => item.varietyId).join(','),
            __repeat: true,
            __warn: true
          }
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功');
            table.value.commitProxy('reload');
          }
        });
      });
    }

    function reset() {
      form.value = {
        prodName: '',
        goodsId: '',
        status: ''
      };
      table.value.commitProxy('reload');
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_image = _resolveComponent("el-image");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, null, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "品种名称"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.prodName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.prodName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "商品ID"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.goodsId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.goodsId = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "状态"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.status,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.status = $event),
                placeholder: ""
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }), _createVNode(_component_el_option, {
                  label: "启用",
                  value: 1
                }), _createVNode(_component_el_option, {
                  label: "停用",
                  value: 0
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: _cache[3] || (_cache[3] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Plus",
          onClick: _cache[4] || (_cache[4] = $event => _unref(router).push({
            name: 'SaveVariety'
          }))
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "success",
          onClick: _cache[5] || (_cache[5] = $event => updateStatus(1))
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "danger",
          onClick: _cache[6] || (_cache[6] = $event => updateStatus(0))
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })]),
        cover: _withCtx(({
          row
        }) => [row.coverUrl ? (_openBlock(), _createBlock(_component_el_image, {
          key: 0,
          style: {
            "width": "60px",
            "height": "60px"
          },
          src: row.coverUrl,
          "preview-src-list": [row.coverUrl],
          fit: "cover"
        }, null, 8, ["src", "preview-src-list"])) : (_openBlock(), _createElementBlock("span", _hoisted_6, "-"))]),
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          type: "success",
          onClick: $event => goEdit(row, true)
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: $event => goEdit(row, false)
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 16)]);
    };
  }

};